import debounce from 'lodash/debounce';
import { setMaxHeightStyle } from '../../../scripts/utils/setMaxHeightStyle';

export const initInstallationSpecSection = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle(
      '[data-pro-multifamily-installation-specifications-block-collapsible-body]'
    );
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};
